/**
 * FORM — activewear / fitness apparel pop-up (demo brand).
 * Garments rendered as stylized folded panels (v1). Production path: real
 * Blender cloth-sim .glb via product.model — drop in /public/models/ and add
 * `model: '/models/tee.glb'` to any entry to upgrade from primitive to mesh.
 */
export const brand = {
  name: 'FORM',
  industry: 'lifestyle',
  template: 'pop',
  tagline: 'Wear the work.',
  drop: { label: 'Capsule 01', endsInHours: 96 },
  // Technical activewear identity: grotesk display, cool charcoal, single accent.
  theme: {
    display: "'Space Grotesk', 'Archivo', sans-serif",
    body: "'Inter', system-ui, sans-serif",
    ink: '#eef0f2',      // light text
    paper: '#0c0e12',    // cool charcoal page
    a1: '#00ffff',       // technical cyan (the single accent)
    a2: '#7dd3ff',       // pale blue
    a3: '#ffffff',       // white
  },
  // Precise, restrained: light bloom, slow controlled motion, tight framing.
  look: {
    exposure: 1.0, envIntensity: 0.85,
    bloomStrength: 0.3, bloomRadius: 0.5, bloomThreshold: 0.75,
    rimLightColor: '#00ffff', rimLightIntensity: 1.0,
    mouseParallax: 0.12, activeScale: 1.12, activeLift: 0.08,
  },
  hero: {
    eyebrow: 'Capsule 01 · 96-hour pop-up',
    headline: 'Wear\nthe <em>work.</em>',
    lede: 'A five-piece capsule. Four days only. Pieces are made to order when the timer ends.',
    cta: 'Shop the capsule',
  },
  manifesto: {
    title: 'Move.\nSweat.\nRepeat.',
    body: 'Cut for output, not the gram. Four-way stretch, flatlock seams, weightless where it matters.',
  },
  // REAL fulfillment: print-on-demand apparel, no inventory, global fulfillment.
  // Each product maps to a Printful catalog blank — your design, they print + ship.
  fulfillment: {
    partner: 'Printful',
    url: 'https://printful.com',
    model: 'Print-on-demand apparel · no inventory · global fulfillment · Shopify',
    cost: 'Free + per-item',
    margin: '30–50%',
  },
};

// Each product maps to a real Printful catalog blank (source).
export const products = [
  {
    id: 'tee', name: 'CORE TEE', tag: 'Heavyweight Tee · unisex', price: '$42',
    source: 'Printful — Bella+Canvas 3001 / Gildan Heavy',
    shape: 'garment', framing: 'square', material: 'fabric',
    colorA: '#0a0a0a', colorB: '#2a2a2a', accent: '#39ff14', mood: 'midnight',
    variants: [
      { sku: 'TEE-BLK',  name: 'Black', colorA: '#0a0a0a', colorB: '#2a2a2a', accent: '#39ff14', price: '$42' },
      { sku: 'TEE-BONE', name: 'Bone',  colorA: '#ece6d8', colorB: '#cfc7b3', accent: '#ff1493', price: '$42' },
      { sku: 'TEE-CLAY', name: 'Clay',  colorA: '#9c5a3c', colorB: '#7a4530', accent: '#00ffff', price: '$42' },
    ],
  },
  {
    id: 'hoodie', name: 'VAPOR HOODIE', tag: 'Premium Hoodie · fleece', price: '$68',
    source: 'Printful — Unisex Premium Hoodie (Gildan 18500 / Cotton Heritage)',
    shape: 'garment', framing: 'square', material: 'fabric',
    colorA: '#3a3a4a', colorB: '#22222e', accent: '#ffaa00', mood: 'storm',
  },
  {
    id: 'short', name: 'SPRINT SHORT', tag: 'Athletic Shorts · lined', price: '$44',
    source: 'Printful — Unisex Athletic Shorts (AOP)',
    shape: 'garment', framing: 'landscape', material: 'fabric',
    colorA: '#1f3a5f', colorB: '#11243d', accent: '#00ffff', mood: 'storm',
  },
  {
    id: 'cap', name: 'RANGE CAP', tag: '5-Panel Cap · packable', price: '$28',
    source: 'Printful — 5-Panel / Dad Cap',
    shape: 'cube', framing: 'square', material: 'fabric',
    colorA: '#39ff14', colorB: '#0a0a0a', accent: '#ff1493', mood: 'pop',
  },
  {
    id: 'bottle', name: 'FLOW BOTTLE', tag: 'Stainless Bottle · 700ml', price: '$29',
    source: 'Printful — Stainless Steel Water Bottle',
    shape: 'bottle', framing: 'tall', material: 'metal',
    colorA: '#ff1493', colorB: '#0a0a0a', accent: '#39ff14', mood: 'pop',
  },
];

export const moodTints = {
  pop: '#0d0d0d', sun: '#1a1206', storm: '#0a1018', mint: '#08160d', midnight: '#0c0c10',
};
